import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import classNames from "classnames";

const NoticeTooltip = ({ content, tooltipCSSClasses, show }) => (
  // "tooltip" class must be last in the bsClass list!
  <Tooltip id="tooltip"
            bsClass={ classNames({ show: show }, tooltipCSSClasses, "default tooltip") }>
    <div className="content">
      { content }
    </div>
  </Tooltip>
)

const NoticeTooltipOnHover = ({tooltipCSSClasses, tooltipPosition, content, children, show }) => {
  const tooltip = NoticeTooltip({ content, tooltipCSSClasses, show });

  return (
    <OverlayTrigger placement={ tooltipPosition }
                    overlay={tooltip}
                    delay={0}>
      { children }
    </OverlayTrigger>
  )
}

export default NoticeTooltipOnHover ;
